
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interfaith",
      function () {
        return require("private-next-pages/interfaith.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interfaith"])
      });
    }
  